import { mutateGraphQL } from '~/hooks/graphql.js';

const newsletterSignupMutation = `
  mutation NewsletterSignup($name: String!, $email: String!, $trigger: String, $captchaToken: String!) {
		newsletterSignup(input: { name: $name, email: $email, trigger: $trigger, captchaToken: $captchaToken }) {
			status
			message
		}
	}
`;

/**
 * Returns result from mutation.
 * 
 * { status, message }
 *
 */
export async function newsletterSignupMutationHandler ({ name, email, trigger, captchaToken }) {
  const { mutationHandler } = mutateGraphQL(newsletterSignupMutation);

  return await mutationHandler({ name, email, trigger, captchaToken });
}
